// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1x2mu","footer":"ModalError_footer__2g7su"};